module.exports = __webpack_public_path__ + "img/6.cfaa9118.jpg";